/**
 * Anticipo en euros enteros (misma lógica que el backend para el portal de reservas).
 */
export function computePortalDepositEuros(totalEur, percent) {
  const t = Number(totalEur);
  const p = Number(percent);
  if (!Number.isFinite(t) || t <= 0 || !Number.isFinite(p) || p <= 0) return 0;
  const raw = (t * p) / 100;
  const rounded = Math.round(raw);
  return Math.max(1, Math.min(rounded, Math.floor(t)));
}
